import { AuthServiceProvider } from './../../providers/auth-service/auth-service';
import { TabsPage } from './../tabs/tabs';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';

/**
page is the inital landing page of the application 
ROles
Will show the carcardiac care branding 
Present with the login screen
If there is a valid login sesssion then move on to the app after a delay of 5 sec
Optional:
Quick skip delay on click 
 */

@IonicPage()
@Component({
  selector: 'page-splash',
  templateUrl: 'splash.html',
})
export class SplashPage {
  loginForm: FormGroup;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public $auth: AuthServiceProvider,
    public alertController: AlertController) {
    this.loginForm = new FormGroup({
      userName: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SplashPage');
  }

  login(credentials) {
    this.$auth.signIn(credentials.userName, credentials.password).then(data => {
    }, (err: any) => {
      console.log('the error is', err);
      this.handelLoginError(err.code)
    })
  }

  /**
   * displays error messages to the users
   */
  handelLoginError(errorCode) {
    switch (errorCode) {
      case 'auth/invalid-email':
        this.showAlert('Login Error', 'Invalid Email Please try again');
        break;
      case 'auth/user-not-found':
        this.showAlert('User Not found', 'The user name entered is not available in the system');
        break;
      case 'auth/wrong-password':
        this.showAlert('Login error', 'The password you have entered is incorrect');
        break;
      case 'auth/user-disabled':
        this.showAlert('User Disabled', 'Your user account is disabled ,please contact Carcadiac Care H.O');
        break;
      default:
        this.showAlert('Login Error', 'There is some error loggin in to your account please try again ');
        break
    }
  }

  // show the alert to the users
  showAlert(title, description) {
    this.alertController.create({
      title: title,
      message: description,
      buttons: ['OK']
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/splash/splash.ts